import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _wrapNativeSuper from "/app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
import { mergeH5PIntegration } from './h5p-utils';
import { addScripts } from './dom-utils';
export var H5PEditorComponent = /*#__PURE__*/function (_HTMLElement) {
  function H5PEditorComponent() {
    var _this;
    _classCallCheck(this, H5PEditorComponent);
    _this = _callSuper(this, H5PEditorComponent);
    /**
     * Call this method when the iframe containing the editor needs to be
     * resized, e.g. because the some
     */
    _this.resize = function () {
      var _a, _b, _c;
      var h5pEditorIframe = _this.querySelector('.h5p-editor-iframe');
      if (h5pEditorIframe) {
        var newHeight = (_c = (_b = (_a = h5pEditorIframe.contentWindow) === null || _a === void 0 ? void 0 : _a.document) === null || _b === void 0 ? void 0 : _b.body) === null || _c === void 0 ? void 0 : _c.scrollHeight;
        if (newHeight !== undefined) {
          h5pEditorIframe.style.height = "".concat(h5pEditorIframe.contentWindow.document.body.scrollHeight.toString(), "px");
        }
      }
    };
    /**
     * Call save() to get data from the H5P editor and send it to the server.
     * You can use the saveContentCallback hook to customize server requests.
     * The component emits 'saved', 'save-error' and 'validation-error' events,
     * depending on success of the function. You can subscribe to those or use
     * the promise's return value and catch the errors in a try-catch block.
     * @throws an error if something went wrong
     * @returns the contentId and metadata of the saved content
     */
    _this.save = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var params, content, saveResponseObject, requestBody;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (_this.editorInstance === undefined) {
              _this.dispatchAndThrowError('save-error', 'editorInstance of h5p editor not defined.');
            }
            if (!_this.saveContentCallback) {
              _this.dispatchAndThrowError('save-error', 'saveContentCallback of H5P Editor Web Component not defined.');
            }
            // Get parameters (and also validates them as a side effect)
            params = _this.editorInstance.getParams();
            if (!params.params) {
              _this.dispatchAndThrowError('validation-error', 'The parameters entered by the user are invalid.');
            }
            // Validate mandatory main title. Prevent submitting if that's not set.
            // Deliberately doing it after getParams(), so that any other validation
            // problems are also revealed.
            if (!_this.editorInstance.isMainTitleSet()) {
              _this.dispatchAndThrowError('validation-error', "The main title of the content hasn't been set.");
            }
            _context.prev = 5;
            _context.next = 8;
            return new Promise(function (res, rej) {
              // By calling getContent we also upgrade the content (this
              // is an unexpected side effect)
              _this.editorInstance.getContent(function (c) {
                res(c);
              }, function (err) {
                rej(err);
              });
            });
          case 8:
            content = _context.sent;
            _context.next = 14;
            break;
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](5);
            _this.dispatchAndThrowError('validation-error', _context.t0.toString());
          case 14:
            requestBody = {
              library: content.library,
              params: JSON.parse(content.params)
            };
            _context.prev = 15;
            _context.next = 18;
            return _this.saveContentCallback(_this.contentId === 'new' ? undefined : _this.contentId, requestBody);
          case 18:
            saveResponseObject = _context.sent;
            _context.next = 24;
            break;
          case 21:
            _context.prev = 21;
            _context.t1 = _context["catch"](15);
            _this.dispatchAndThrowError('save-error', _context.t1.message);
          case 24:
            if (_this.contentId !== saveResponseObject.contentId) {
              _this.setAttribute('content-id', saveResponseObject.contentId);
            }
            _this.dispatchEvent(new CustomEvent('saved', {
              detail: {
                contentId: saveResponseObject.contentId,
                metadata: saveResponseObject.metadata
              }
            }));
            return _context.abrupt("return", saveResponseObject);
          case 27:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[5, 11], [15, 21]]);
    }));
    /**
     * Called by the global H5P event dispatcher when any editor was loaded.
     */
    _this.onEditorLoaded = function (event) {
      var _a;
      // We must manually check if our editor instance is initialized, as the
      // event is only sent globally.
      if (_this.editorInstance.selector.form) {
        _this.dispatchEvent(new CustomEvent('editorloaded', {
          detail: {
            contentId: _this.contentId,
            ubername: event.data
          }
        }));
        // After our editor has been initialized, it will never fire the
        // global event again, so we can unsubscribe from it.
        if ((_a = window.H5P) === null || _a === void 0 ? void 0 : _a.externalDispatcher) {
          window.H5P.externalDispatcher.off('editorloaded', _this.onEditorLoaded);
        }
      }
    };
    H5PEditorComponent.initTemplate();
    return _this;
  }
  _inherits(H5PEditorComponent, _HTMLElement);
  return _createClass(H5PEditorComponent, [{
    key: "contentId",
    get: function get() {
      var _a;
      return (_a = this.getAttribute('content-id')) !== null && _a !== void 0 ? _a : undefined;
    },
    set: function set(contentId) {
      if (!contentId) {
        this.removeAttribute('content-id');
      } else {
        this.setAttribute('content-id', contentId);
      }
    }
    /**
     * Called when the component needs to load data about content. The endpoint
     * called in here combines the results of H5PEditor.render(...) and
     * H5PEditor.getContent(...) to avoid too many requests.
     *
     * Note that the library, metadata and params property of the returned
     * object must only be defined if contentId is defined.
     *
     * Should throw an error with a message in the message property if something
     * goes wrong.
     */
  }, {
    key: "loadContentCallback",
    get: function get() {
      return this.privateLoadContentCallback;
    },
    set: function set(callback) {
      // We only (re-)render the component if the callback was really changed.
      var mustRender = this.privateLoadContentCallback !== callback;
      this.privateLoadContentCallback = callback;
      if (mustRender) {
        this.render(this.contentId);
      }
    }
    /**
     * Indicates changes to which attributes should trigger calls to
     * attributeChangedCallback.
     */
  }, {
    key: "attributeChangedCallback",
    value: (
    /**
     * Called when one of the attributes in observedAttributes changes.
     */
    function () {
      var _attributeChangedCallback = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(name, oldVal, newVal) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(name === 'content-id' && oldVal !== newVal && oldVal !== 'new')) {
                _context2.next = 3;
                break;
              }
              _context2.next = 3;
              return this.render(newVal);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function attributeChangedCallback(_x, _x2, _x3) {
        return _attributeChangedCallback.apply(this, arguments);
      }
      return attributeChangedCallback;
    }()
    /**
     * Called when the component is added to the DOM.
     */
    )
  }, {
    key: "connectedCallback",
    value: (function () {
      var _connectedCallback = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this2 = this;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.appendChild(H5PEditorComponent.template.content.cloneNode(true));
              this.root = this.querySelector('.h5p-editor-component-root');
              this.resizeObserver = new ResizeObserver(function () {
                _this2.resize();
              });
              this.resizeObserver.observe(this);
              _context3.next = 6;
              return this.render(this.contentId);
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }
      return connectedCallback;
    }()
    /**
     * Called when the component is removed from the DOM.
     */
    )
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var _a;
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
      // Unregister our event listener from the global H5P dispatcher.
      if ((_a = window.H5P) === null || _a === void 0 ? void 0 : _a.externalDispatcher) {
        window.H5P.externalDispatcher.off('editorloaded', this.onEditorLoaded);
      }
    }
    /**
     * Dispatches an event of the specified name and throws an error whose error
     * message starts with the eventName.
     * @param eventName
     * @param message
     */
  }, {
    key: "dispatchAndThrowError",
    value: function dispatchAndThrowError(eventName, message) {
      this.dispatchEvent(new CustomEvent(eventName, {
        detail: {
          message: message
        }
      }));
      throw new Error("".concat(eventName, ": ").concat(message));
    }
    /**
     * Displays the editor inside the component by creating a new DOM tree.
     * @param contentId the content id to display or undefined if a new piece
     * of content was created
     */
  }, {
    key: "render",
    value: (function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(contentId) {
        var editorModel, h5pCreateDiv, h5pEditorDiv;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (this.loadContentCallback) {
                _context4.next = 2;
                break;
              }
              return _context4.abrupt("return");
            case 2:
              if (contentId) {
                _context4.next = 4;
                break;
              }
              return _context4.abrupt("return");
            case 4:
              _context4.prev = 4;
              _context4.next = 7;
              return this.loadContentCallback(contentId === 'new' ? undefined : contentId);
            case 7:
              editorModel = _context4.sent;
              _context4.next = 14;
              break;
            case 10:
              _context4.prev = 10;
              _context4.t0 = _context4["catch"](4);
              this.root.innerHTML = "<p>Error loading H5P content from server: ".concat(_context4.t0.message);
              return _context4.abrupt("return");
            case 14:
              // Reset DOM tree inside component.
              this.root.innerHTML = '';
              // We have to prevent H5P from initializing when the h5p.js file is
              // loaded.
              if (!window.H5P) {
                window.H5P = {};
              }
              window.H5P.preventInit = true;
              // We merge the H5P integration we received from the server with the one
              // that already exists in the window globally to allow for several H5P
              // content objects on a single page.
              mergeH5PIntegration(editorModel.integration, contentId === 'new' ? undefined : contentId);
              // As the editor adds an iframe anyway and styles don't really matter, we
              // only add the global editor scripts to the whole page, but not the styles
              // (to avoid side effects).
              _context4.next = 20;
              return addScripts(editorModel.scripts, document.getElementsByTagName('head')[0]);
            case 20:
              // Create the necessary DOM tree.
              h5pCreateDiv = document.createElement('div');
              h5pCreateDiv.className = 'h5p-create';
              h5pCreateDiv.hidden = true;
              this.root.appendChild(h5pCreateDiv);
              h5pEditorDiv = document.createElement('div');
              h5pEditorDiv.className = 'h5p-editor';
              h5pCreateDiv.appendChild(h5pEditorDiv);
              // Set up the H5P core editor.
              H5PEditor.getAjaxUrl = function (action, parameters) {
                var url = editorModel.integration.editor.ajaxPath + action;
                if (parameters !== undefined) {
                  for (var property in parameters) {
                    if (Object.prototype.hasOwnProperty.call(parameters, property)) {
                      url = "".concat(url, "&").concat(property, "=").concat(parameters[property]);
                    }
                  }
                }
                url += window.location.search.replace(/\\?/g, '&');
                return url;
              };
              window.H5P.preventInit = false;
              // Only initialize H5P once to avoid resetting values.
              if (!window.h5pIsInitialized) {
                window.H5P.init(this.root);
                window.h5pIsInitialized = true;
              }
              // Register our global editorloaded event handler.
              if (window.H5P.externalDispatcher) {
                window.H5P.externalDispatcher.on('editorloaded', this.onEditorLoaded, this);
              }
              // Configure the H5P core editor.
              H5PEditor.$ = window.H5P.jQuery;
              H5PEditor.basePath = editorModel.integration.editor.libraryUrl;
              H5PEditor.fileIcon = editorModel.integration.editor.fileIcon;
              H5PEditor.ajaxPath = editorModel.integration.editor.ajaxPath;
              H5PEditor.filesPath = editorModel.integration.editor.filesPath;
              H5PEditor.apiVersion = editorModel.integration.editor.apiVersion;
              H5PEditor.contentLanguage = editorModel.integration.editor.language;
              H5PEditor.copyrightSemantics = editorModel.integration.editor.copyrightSemantics;
              H5PEditor.metadataSemantics = editorModel.integration.editor.metadataSemantics;
              H5PEditor.assets = editorModel.integration.editor.assets;
              H5PEditor.baseUrl = '';
              H5PEditor.contentId = contentId === 'new' ? undefined : contentId;
              H5PEditor.enableContentHub = editorModel.integration.editor.enableContentHub || false;
              if (contentId === 'new') {
                // Create an empty editor for new content
                this.editorInstance = new ns.Editor(undefined, undefined, h5pEditorDiv);
              } else {
                // Load the editor with populated parameters for existing content
                this.editorInstance = new ns.Editor(editorModel.library, JSON.stringify({
                  metadata: editorModel.metadata,
                  params: editorModel.params
                }), h5pEditorDiv);
              }
              h5pCreateDiv.hidden = false;
            case 46:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[4, 10]]);
      }));
      function render(_x4) {
        return _render.apply(this, arguments);
      }
      return render;
    }())
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ['content-id', 'h5p-url'];
    }
  }, {
    key: "initTemplate",
    value: function initTemplate() {
      // We create the static template only once
      if (!H5PEditorComponent.template) {
        H5PEditorComponent.template = document.createElement('template');
        H5PEditorComponent.template.innerHTML = "\n            <style>\n            .h5peditor-semi-fullscreen {\n                margin: 0;\n                padding: 0;\n                position: fixed;\n                overflow-y: scroll;\n                box-sizing: border-box;\n                height: 100%;\n                width: 100%;\n                left: 0;\n                top: 0;\n            }\n            </style>\n            <div class=\"h5p-editor-component-root\"></div>";
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
//# sourceMappingURL=h5p-editor.js.map